export const formatPriceInput = (value: number | string) => {
	if (value === null || value === undefined || value === "") return "";

	const number = typeof value === "string" ? parseFloat(value) : value;

	if (isNaN(number)) return value.toString();

	return number.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		maximumFractionDigits: 0,
	});
};
